import { tempMeeApi } from '~/services/api';
import { scopedHeaders } from './scopedHeaders';
import type { IOfficeMissingInfoUsersPatch } from '../types/OfficeMissingInfo.api';

export const updateOfficeInfo = async (
  payload: IOfficeMissingInfoUsersPatch,
  officeId?: string | null,
): Promise<void> => {
  const headers = await scopedHeaders(officeId);
  await tempMeeApi.patch('/users', payload, { headers });
};
